module.exports = __webpack_public_path__ + "img/smoked.d7165b9d.png";